jQuery(document).ready(function () {
  jQuery('#acf_fields').removeClass('closed');
});
